import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import ExclamationIcon from 'dibs-icons/exports/legacy/ExclamationCircle';

import styles from './styles/DesignerDirectoryError.scss';

export const DesignerDirectoryError: FC = () => (
    <div className={styles.wrapper}>
        <div className={styles.icon}>
            <ExclamationIcon className={styles.icon} />
        </div>
        <div className={styles.heading} data-tn="design-directory-error-heading">
            <FormattedMessage
                id="abt.DesignerDirectoryError.errorHeading"
                defaultMessage="There was an issue loading designers."
            />
        </div>
        <div className={styles.subheading} data-tn="design-directory-error-subheading">
            <FormattedMessage
                id="abt.DesignerDirectoryError.errorAdvice"
                defaultMessage="Please refresh your browser or try again later."
            />
        </div>
    </div>
);
